<template>
  <div class="p-3">
    <h2 class="font-normal ml-4 m-0">Good {{ timeOfDay }}, <span class="font-bold">{{ user.profile.displayName }}!</span></h2>
    <QuickActionCards />
    <RecentlyUsed />
    <TeamMembers />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';

import useUserStore from '@/stores/user';

import QuickActionCards from '@/components/QuickActionCards.vue';
import RecentlyUsed from '@/components/RecentlyUsed.vue';
import TeamMembers from '@/components/TeamMembers.vue';

const { user } = storeToRefs(useUserStore());

const hour = new Date().getHours();

const timeOfDay = computed(() => {
  switch (true) {
    case hour < 12:
      return 'morning';
    case hour < 18:
      return 'afternoon';
    default:
      return 'evening';
  }
});
</script>
